import React from "react";
import { Layout } from "antd";

const ClientLoginLayout = ({className, ...props}) => {
  return <Layout className={`${className}`}>{props.children}</Layout>;
};

export default ClientLoginLayout;
